import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { AuthState, UserSession, WorkspaceContext } from '../types/authTypes';

const initialState: AuthState = {
  status: 'restoring',
  user: undefined,
  error: undefined,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setRestoring(state) {
      state.status = 'restoring';
      state.error = undefined;
    },
    setAuthenticating(state) {
      state.status = 'authenticating';
      state.error = undefined;
    },
    setWorkspaceSelecting(state, action: PayloadAction<UserSession>) {
      state.status = 'workspace_selecting';
      state.user = action.payload;
      state.error = undefined;
    },
    setAuthenticated(state, action: PayloadAction<UserSession>) {
      state.status = 'authenticated';
      state.user = action.payload;
      state.error = undefined;
    },
    setWorkspaceAuthenticated(state, action: PayloadAction<WorkspaceContext>) {
      state.status = 'authenticated';
      if (state.user) {
        state.user.workspaceContext = action.payload;
        state.user.status = 'authenticated';
      }
      state.error = undefined;
    },
    setRefreshing(state) {
      state.status = 'refreshing';
      state.error = undefined;
    },
    setUnauthenticated(state) {
      state.status = 'unauthenticated';
      state.user = undefined;
      state.error = undefined;
    },
    setReauthRequired(state, action: PayloadAction<string | undefined>) {
      state.status = 'reauth_required';
      state.user = undefined;
      state.error = action.payload;
    },
  },
});

export const {
  setRestoring,
  setAuthenticating,
  setWorkspaceSelecting,
  setAuthenticated,
  setWorkspaceAuthenticated,
  setRefreshing,
  setUnauthenticated,
  setReauthRequired,
} = authSlice.actions;

export const authReducer = authSlice.reducer;
export default authReducer;
